(() => {
  if (window.doyoVariantCascadeInitialized) return;
  window.doyoVariantCascadeInitialized = true;

  const pickerSelector = 'variant-selects[data-doyo-variant-cascade]';
  const groupSelector = 'fieldset, .product-form__input--dropdown';
  const dataSelector = '[data-doyo-variant-cascade-data]';
  const logPrefix = '[Doyo Variant Cascade]';

  const parsePickerData = (picker) => {
    const dataNode = picker.querySelector(dataSelector);
    if (!dataNode) return null;

    try {
      return JSON.parse(dataNode.textContent);
    } catch (error) {
      // console.warn(`${logPrefix} 变体数据解析失败`, error);
      return null;
    }
  };

  const getSelectedValue = (group) => {
    const selectedRadio = group.querySelector('input[type="radio"]:checked');
    if (selectedRadio) return selectedRadio.value;

    return group.querySelector('select option:checked')?.value;
  };

  const matchesPrefix = (variant, values) => values.every((value, index) => !value || variant.options[index] === value);

  const resolveSelection = (variants, selectedValues, changedIndex) => {
    const resolvedValues = selectedValues.slice();
    const fixedValues = resolvedValues.slice(0, changedIndex + 1);

    if (!variants.some((variant) => variant.available && matchesPrefix(variant, fixedValues))) return null;

    for (let index = changedIndex + 1; index < resolvedValues.length; index += 1) {
      const currentValue = resolvedValues[index];
      const compatibleVariant = variants.find(
        (variant) =>
          variant.available &&
          matchesPrefix(variant, resolvedValues.slice(0, index)) &&
          (!currentValue || variant.options[index] === currentValue)
      );

      resolvedValues[index] = compatibleVariant?.options[index] || variants.find(
        (variant) => variant.available && matchesPrefix(variant, resolvedValues.slice(0, index))
      )?.options[index];

      if (!resolvedValues[index]) return null;
    }

    return resolvedValues;
  };

  const findOptionValueId = (optionValues, groupIndex, value) =>
    optionValues[groupIndex]?.values.find((optionValue) => optionValue.value === value)?.id;

  const selectRenderedValue = (group, value) => {
    group.querySelectorAll('[data-doyo-variant-cascade-hidden]').forEach((input) => input.remove());

    const radio = Array.from(group.querySelectorAll('input[type="radio"]')).find((input) => input.value === value);
    if (radio) {
      radio.checked = true;
      return true;
    }

    const option = Array.from(group.querySelectorAll('select option')).find((item) => item.value === value);
    if (option) {
      option.selected = true;
      return true;
    }

    return false;
  };

  const addHiddenSelection = (group, groupIndex, value, optionValueId, optionName) => {
    group.querySelectorAll('[data-doyo-variant-cascade-hidden]').forEach((input) => input.remove());

    const input = document.createElement('input');
    const existingRadio = group.querySelector('input[type="radio"]');

    input.type = 'radio';
    input.name = existingRadio?.name || `doyo-cascade-option-${groupIndex}`;
    input.value = value;

    if (existingRadio?.hasAttribute('form')) {
      input.setAttribute('form', existingRadio.getAttribute('form'));
    }

    input.hidden = true;
    input.dataset.doyoVariantCascadeHidden = '';
    input.dataset.optionValueId = optionValueId;
    input.dataset.optionName = optionName;
    group.append(input);
    input.checked = true;
    // console.log(`${logPrefix} 已添加临时隐藏选中项`, { groupIndex, value, optionValueId });
  };

  const prepareDownstreamSelections = (picker, changedGroup) => {
    const data = parsePickerData(picker);
    if (!data?.variants?.length || !data?.optionValues?.length) return;

    const groups = Array.from(picker.querySelectorAll(groupSelector));
    const changedIndex = groups.indexOf(changedGroup);
    if (changedIndex === -1 || changedIndex === groups.length - 1) return;

    const selectedValues = groups.map(getSelectedValue);
    const resolvedValues = resolveSelection(data.variants, selectedValues, changedIndex);
    if (!resolvedValues) {
      // console.log(`${logPrefix} 未找到与当前上级选择兼容的可售变体，不补选下级`, { selectedValues });
      return;
    }

    let didPrepareSelection = false;

    for (let index = changedIndex + 1; index < groups.length; index += 1) {
      if (selectedValues[index] === resolvedValues[index]) continue;

      const optionValueId = findOptionValueId(data.optionValues, index, resolvedValues[index]);
      if (!optionValueId) {
        // console.warn(`${logPrefix} 缺少 option value ID，无法预补选`, { groupIndex: index, value: resolvedValues[index] });
        return;
      }

      if (!selectRenderedValue(groups[index], resolvedValues[index])) {
        addHiddenSelection(groups[index], index, resolvedValues[index], optionValueId, data.optionValues[index].name);
      }

      didPrepareSelection = true;
    }

    if (didPrepareSelection) {
      // console.log(`${logPrefix} 已在 Dawn 请求前补齐下级选择`, { selectedValues, resolvedValues });
    } else {
      // console.log(`${logPrefix} 下级已有兼容选中项，无需补选`, { selectedValues });
    }
  };

  document.addEventListener(
    'change',
    (event) => {
      const control = event.target;
      if (!(control instanceof HTMLInputElement || control instanceof HTMLSelectElement)) return;

      const picker = control.closest(pickerSelector);
      const group = control.closest(groupSelector);
      if (!picker || !group || control.dataset.doyoVariantCascadeHidden !== undefined) return;

      prepareDownstreamSelections(picker, group);
    },
    true
  );
})();
